export default "__VITE_ASSET__47d70435__"